export default __webpack_public_path__ + "static/partners01-af65ddd680adb95bed3015b837fe0992.png";